import { render, staticRenderFns } from "./RestoreStudentsDialog.vue?vue&type=template&id=38530a9e"
import script from "./RestoreStudentsDialog.vue?vue&type=script&lang=js"
export * from "./RestoreStudentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports